import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import classNames from 'classnames';
import UMOGridItem from '../UMOGridItem';

function WorkspacePreviewItem({
  dispatch,
  isSelected,
  umo,
  onDetailViewClick,
  selectedWorkspaceData,
}) {
  return (
    <div
      className={classNames('workspace-preview__umo-item', {
        'workspace-preview__umo-item--selected': isSelected,
      })}
    >
      <UMOGridItem
        onDetailViewClick={onDetailViewClick}
        classModifier="umo-grid-item--workspace-preview"
        overlayClassModifier="umo-grid-item__overlay--workspace-preview"
        umo={umo}
        isSelected={isSelected}
        isWorkspaceItem
        dispatch={dispatch}
        selectedWorkspaceData={selectedWorkspaceData}
        isUMOGalleryWorkspace
        isSelectableItem={false}
      />
    </div>
  );
}

WorkspacePreviewItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  onDetailViewClick: PropTypes.func,
  dispatch: PropTypes.func,
  isSelected: PropTypes.bool,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default WorkspacePreviewItem;
